import PageDictionaryEdit from './PageDictionaryEdit';



export default PageDictionaryEdit;
